import { getMessageStoragePath } from './getMessageStoragePath'

interface Props {
  workspaceId: string
  taskId: string
  messageId: string
  fileName: string
}

export const getMessageFileOriginalPath = ({
  workspaceId,
  taskId,
  messageId,
  fileName,
}: Props): string => {
  const path = getMessageStoragePath({ workspaceId, taskId, messageId })

  return `${path}${fileName}`
}
